import { Alert, Box, Tab, Tabs } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MemberFormConfigurator } from '../components/memberFormConfigurator';

export const MemberRegistryFormsPage = () => {
  const { t } = useTranslation(['settings']);
  const [activeTab, setActiveTab] = useState(0);

  const formNames = ['member', 'other', 'mypagepersonal'] as const;
  const tabLabels = [t('settings:memberRegistry.formMember'), t('settings:memberRegistry.formOther'), t('settings:memberRegistry.formMypage')];

  return (
    <Box>
      <Alert severity='warning'>{t('settings:memberRegistry.settingsWarning')}</Alert>
      <Tabs
        value={activeTab}
        onChange={(_, val) => setActiveTab(val)}
        sx={{ borderTop: 1, borderBottom: 1, borderColor: 'divider', '& button': { textTransform: 'none' } }}
      >
        {tabLabels.map((label, idx) => (
          <Tab key={formNames[idx]} label={label} />
        ))}
      </Tabs>
      <MemberFormConfigurator formName={formNames[activeTab]} />
    </Box>
  );
};
